// extracted by mini-css-extract-plugin
module.exports = {"titleWrap":"Header_titleWrap__wbuef","title":"Header_title__FvZrX","link":"Header_link__RGzcw","arrowRight":"Header_arrowRight__CDJ6U"};